/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/naming-convention */
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewEncapsulation,
} from '@angular/core';
import { UtilityService } from 'app/core/services/utility_functions/utility_functions.service';
import { DataCollectorService } from 'app/core/services/data_collector_services/data_collector_service.service';
import { JobsService } from 'app/core/services/jobs/jobs.service';
import dayjs from 'dayjs';
import moment from 'moment';
import { HotToastService } from '@ngneat/hot-toast';
import { MatCalendarCellClassFunction } from '@angular/material/datepicker';
import { MapsService } from 'app/modules/maps/maps.service';
import { DispatchBoardService } from '../../../../projects/dispatch-board/src/app/components/dispatch-board/dispatch-board.service';

@Component({
  selector: 'app-assign-route-component',
  templateUrl: './assign-route.component.html',
  styleUrls: ['./assign-route.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AssignRouteComponent implements OnInit, OnChanges {
  @Input()date: any = moment(new Date());
  @Input()routeSelected?: any = '';
  @Output() routeUnlockEvent: EventEmitter<any> = new EventEmitter();

  searchText: string = '';
  pagination: any = {
    totalRecords: 0,
    pageIndex: 1,
    pageSize: 10
  };
  routes: any = [];
  showDataIndex: number;
  showData: boolean = false;
  companyConfig: any;
  object: Object;
  allRouteCount: any;
  isRouteLoading: boolean = false;
  routeParams: any;
  sortParams = { sortBy: 'departure', sortType: 'ASC', sortByDisplayName: 'Departure' };
  sortItems = [{
    'displayName': 'Departure',
    'displayKey': 'text.departure',
    'sortKey': 'departure'
  }, {
    'displayName': 'Route Name',
    'displayKey': 'text.route_name',
    'sortKey': 'route_name'
  }]

  constructor(public utilityService: UtilityService,
              private dataCollectorService: DataCollectorService,
              private jobService: JobsService,
              private toast: HotToastService,
              private mapService: MapsService,
              private _dispatchBoardService: DispatchBoardService,
              private changeDetectorRef: ChangeDetectorRef
              ) {}

  ngOnInit(): void {
    this.companyConfig = this.utilityService.companyConfig;
    this.getRoutes();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if('routeSelected' in changes){
      this.routeSelected = changes.routeSelected.currentValue;
    }
    if('date' in changes){
      this.date = changes.date.currentValue;
    }
  }

  dateClass: MatCalendarCellClassFunction<Date> = (cellDate, view) => {
    if ((moment(cellDate).date() === 1) &&
        (view === 'month')
       )
    {
       this.changeMonth(cellDate);
    };
    return '';
  };

  changeMonth(date: any): void {
    this.getRoutesCount(date);
  }

  changeSortType(): void {
    this.sortParams.sortType = this.sortParams.sortType === 'ASC' ? 'DESC' : 'ASC';
    this.pagination['pageIndex'] = 1;
    this.getRoutes();
  }

  sortMenuClick(item: any): void {
    this.sortParams.sortBy = item.sortKey;
    this.sortParams.sortByDisplayName = item?.displayName;
    this.pagination['pageIndex'] = 1;
    this.getRoutes();
  }

  getRoutesCount(date: any): void {
    const filter = {
      'from_date': date.startOf('month').format('YYYY-MM-DD'),
      'to_date': date.endOf('month').format('YYYY-MM-DD')
    };
    this.dataCollectorService.getData(this.mapService.mapsAPi.getRoutesCount, filter)
      .subscribe((res: any)=>{
        this.allRouteCount = res?.data;
        const calendarDates = document.querySelectorAll('.mat-calendar-body-cell-content');
        this.allRouteCount.forEach((route: any, i: number) =>{
          if(route?.job_routes > 0){
            calendarDates[i].classList.add('route-available');
          }else{
            calendarDates[i].classList.remove('route-available');
          }
        });
      },(err: any) => {

      });
  }

  triggerSearch(event: any): void{
    if (event.keyCode === 13) {
      this.getRoutes();
    }
  }

  onSearchBlur(): void{
    if (this.routeParams?.['filter.keyword'] !== this.searchText) {
      this.searchText = this.routeParams?.['filter.keyword'] || '';
    }
  }

  onPageEvent(event: any): void{
    this.pagination = {
      ...this.pagination,
      pageIndex: event?.pageIndex + 1
    };
    this.getRoutes();
  }

  clearSearch(): void{
    this.searchText = '';
    this.pagination['pageIndex'] = 1;
    this.getRoutes();
  }

  getRoutes(): void{
    this.isRouteLoading = true;
    this.routeParams = {
      'from_date': dayjs(this.date).format('YYYY-MM-DD'),
      'limit': this.pagination?.pageSize,
      'page': this.pagination?.pageIndex,
      'to_date': dayjs(this.date).format('YYYY-MM-DD'),
      'filter.keyword': this.searchText,
      'sort_by': this.sortParams.sortBy,
      'sort': this.sortParams.sortType
    };
    this.dataCollectorService.getData(this.jobService.jobAPIUrls.assignRoutesUrl, this.routeParams).subscribe((response: any) => {
      this.routes = response.data;
      this.pagination = {
        ...this.pagination,
        totalRecords: response?.total_records ?? 0
      };
      this.isRouteLoading = false;
      this.changeDetectorRef.detectChanges();
    },(error: any)=>{
      this.isRouteLoading = false;
      this.changeDetectorRef.detectChanges();
    });
  }

  expandPanel(index): void{
    this.showDataIndex = index;
    this.showData = true;
  }

  onDateChange(event: any): void{
    this.pagination['pageIndex'] = 1;
    this.searchText = '';
    this.getRoutes();
  }

  setSelectedRoute(route): void{
    this.jobService.setSelectedRoute(route);
  }

  unlockRoute(routeDetails: any): void {
    const isRouteLocked = routeDetails?.is_locked;
    const routeUid = routeDetails?.route_uid;
    if (isRouteLocked) {
      const unlockRouteConfirmationDialogRef = this._dispatchBoardService.routeDetailsChangeConfirmationDialog(routeDetails, 'unlockRoute');
      unlockRouteConfirmationDialogRef.afterClosed()
        .subscribe((result) => {
          if (result) {
            const lockUpdateToast = this.toast.loading(this.utilityService.getLocaleValue('route.lock.updating'));
            this._dispatchBoardService.updateRouteLock(routeUid, !isRouteLocked, (status: any) => {
              if (status) {
                lockUpdateToast.close();
                this.routeUnlockEvent.emit({
                  status: 'routeUnlocked',
                  routeUid: routeUid
                });
                this.getRoutes();
              }
              else {
                lockUpdateToast.close();
              }
            });
          }
        });
    }
  }
}
